export const auth = {
  authHomeTitle: 'Let’s get started',
  authHomeButtonBranded: 'Continue with Email',
  authHomeButtonApple: 'Continue with Apple',
  authHomeButtonGoogle: 'Continue with Google',
  authHomeButtonFacebook: 'Continue with Facebook',
  authHomeButtonLinkedin: 'Continue with LinkedIn',
  authStartTitle: 'Login or Sign Up',
  authStartInputTitle: 'E-mail',
  authStartInputTitleError: 'Enter valid E-mail!',
  authStartInputPasswordError: 'Enter valid Password!',
  authWhoops: 'Whoops!',
  authStartConfirmButton: 'Continue',
  authRegisteredTitle: 'Welcome back!',
  authStartPlaceholderTitle: 'E-mail',
  authRegisteredInputTitle: 'Password',
  authRegisteredForgotPassword: 'Forgot password',
  authAlertIncorrectPassword: 'Your Email or Password is incorrect',
  authAlertRequiredPassword: 'Enter valid Password',
  authFinishSignUpTitle: 'Finish Sign Up',
  authFinishSignUpEmailInputTitle: 'E-mail',
  authFinishSignUpFirstNameInputTitle: 'First Name',
  authFinishSignUpLastNameInputTitle: 'Last Name',
  authFinishSignUpPasswordInputTitle: 'Password',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">We recommend to use:</li><li class="list-disc">At least 8 characters</li><li class="list-disc">Include 1 number</li><li class="list-disc">Include 1 special symbol</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: 'By clicking Sign Up you agree to our',
    privacyPolicy: 'Privacy Policy',
    text2: 'and',
    termsOfUse: 'Terms of Use'
  },
  authFinishSignUpConfirmButton: 'Sign Up',
  authFinishSignUpErrorFirstName: "First Name can't be empty!",
  authFinishSignUpErrorLastName: "Last Name can't be empty!",
  authFinishSignUpErrorPassword: 'Password is too short!',
  authEmailConfirmationTitle: 'Check your mailbox',
  authEmailConfirmationContent:
    'We have sent a confirmation email to confirm your email address. Please ensure to check your spam box in case you can’t find it in your inbox.',
  authEmailConfirmationConfirmButton: 'Back to Login',
  authAlertEmailConfirmation: 'Please check your inbox to confirm your email!',
  authResetPasswordTitle: 'Check your mailbox',
  authResetPasswordDescription:
    'We have sent a reset password link to your email. Please ensure to check your spam box in case you can’t find it in your inbox',
  authResetPasswordButton: 'Back to login',
  authNewPasswordTitle: 'Enter new password',
  authNewPasswordInputTitle: 'New password',
  authNewPasswordButton: 'Reset password',
  authNewPasswordAlertValidation: 'Your password is not strong enough',
  authPasswordChangeSuccessTitle: 'Password changed!',
  authPasswordChangeSuccessContent: 'Your password has changed successfully!',
  authPasswordChangeSuccessButton: 'Back to login',
  authPasswordChangeErrorTitle: 'Error!',
  authPasswordChangeErrorContent: 'Something went wrong trying to reset your password! Try again later.',
  authPasswordChangeErrorButton: 'Back to Login',
  authInvitationTitle: 'Choose a password',
  authInvitationInputTitle: 'Password',
  authInvitationButton: 'Setup password',
  authEmailAddressConfirmed: 'Email address confirmed!'
}
